<div id="tile-container" class="tile-container" [ngStyle]="setBgColor()"
[style.background]="this.tile?.color?.hex" (click)="clicked()">
  <img src="./../../assets/img/tile_big_noborder.png" draggable="false">
  <div class="centered noselect">{{this.tile?.tileNumber}}</div>
</div>
